<template>
  <div>
    <b-row style="margin: 5px;">
      <b-form-group>
        <label style="font-weight: bold;">1.Instructor Feedback Survey Report Font Size Settings:</label>
        <div style="display: flex; align-items: center;">
          <b-form-select style="width: 100px; margin-right: 5px;" v-model="reportFontsize" :options="fontsizeOptions"
            value-field="value" text-field="text" :disabled="!editReportFontsize">
          </b-form-select>
          <i v-if="!editReportFontsize && !usersubgroup_id" class="fas fa-edit text-info" style="font-size: 15px !important; cursor: pointer;"
            @click="editReportFontsize = true"></i>
        </div>
      </b-form-group>
    </b-row>
    <!-- Update Button -->
    <b-row style="margin: 5px;" v-if="!usersubgroup_id">
      <b-button variant="primary" @click="setUserGroupsInstructorFeedbackSurveyReportFontsize()">Update</b-button>
    </b-row>
  </div>

</template>

<script>
export default {
  props: ["group_id", "usergroup_id", "usersubgroup_id"],
  async created() {
    await this.getUserGroupsInstructorFeedbackSurveyReportFontsize();
  },
  data() {
    return {
      fontsizeOptions: [
        { value: 9, text: "~9pt" },
        { value: 10, text: "~10pt" },
        { value: 11, text: "~11pt" },
        { value: 12, text: "~12pt (default)" },
        { value: 13, text: "~13pt" },
        { value: 14, text: "~14pt" }
      ],
      reportFontsize: 12, // Set as a number
      editReportFontsize: false,
     
    };
  },
  methods: {
    getUserGroupsInstructorFeedbackSurveyReportFontsize() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups-configuration-groups/setting/${this.group_id}/instructor_feedback_survey_report_fontsize`;
      this.$axios
        .get(url)
        .then((response) => {
          this.reportFontsize = parseInt(response.data) || 12;
        })
        .catch(() => {
          this.reportFontsize = 12;
        });
    },
    async setUserGroupsInstructorFeedbackSurveyReportFontsize() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups-configuration-groups/setting/${this.group_id}/instructor_feedback_survey_report_fontsize`;
      await this.$axios
        .post(url, { instructor_feedback_survey_report_fontsize: this.reportFontsize })
        .then(() => {
          this.editReportFontsize = false;
          this.$toast.success("Updated Report Font Size", {
            position: "top",
            duration: 3000,
          });
        });
    },
  },
};
</script>
